import { Component, Input, OnInit } from '@angular/core';
import { IApiInvestigation, IApiInvestigationOnScene } from 'src/app/shared/modules/graphql/types/types';
import { EnforcePermissionDisplayModes } from 'src/app/shared/directives/enforce-permission.directive';
import {
  timeEntryInvestigationHoursListOwnAssign,
  timeEntryInvestigationHoursCreateOwnAssign,
  timeEntryInvestigationHoursListAll,
} from 'src/app/shared/helpers/auth-config/time-expenses.config';
import { InvestigationOnSceneStatus } from 'src/app/shared/modules/graphql/enums/investigation.enums';

interface OnSceneSummary {
  user: string;
  scheduledDate: string;
  startTime: string | null;
  endTime: string | null;
  duration: string | null;
}

@Component({
  selector: 'app-investigation-time-exp-instructions',
  templateUrl: './investigation-time-exp-instructions.component.html',
  styleUrls: ['./investigation-time-exp-instructions.component.scss'],
})
export class InvestigationTimeExpInstructionsComponent implements OnInit {

  @Input() public investigation: IApiInvestigation;

  public authConfig = {
    timeEntryInvestigationHoursListOwnAssign,
    timeEntryInvestigationHoursCreateOwnAssign,
    timeEntryInvestigationHoursListAll,
  };

  public onSceneSummary: OnSceneSummary[] = [];

  ngOnInit(): void {
    this.onSceneSummary = this.getOnSceneSummary(this.investigation?.OnSceneHistory);
  }

  public getOnSceneSummary(data: IApiInvestigationOnScene[]): OnSceneSummary[] {
    if (!data?.length) return [];

    const map = new Map<string, IApiInvestigationOnScene[]>();

    for (const item of data) {
      const key = item.User.id + '_' + item.scheduledDate;
      if (!map.has(key)) map.set(key, []);
      map.get(key)!.push(item);
    }

    const result: OnSceneSummary[] = [];
    for (const group of map.values()) {
      group.sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());

      const first = group[0];
      const user = first.User;
      const scheduledDate = first.scheduledDate;

      let onScene: IApiInvestigationOnScene | undefined;
      let offScene: IApiInvestigationOnScene | undefined;

      for (const g of group) {
        if (!onScene && g.status === InvestigationOnSceneStatus.ON_SCENE) onScene = g;
        if (g.status === InvestigationOnSceneStatus.OFF_SCENE) offScene = g;
      }

      let duration: string | null = null;

      if (onScene && offScene) {
        const diff = Math.floor(
          (new Date(offScene.createdAt).getTime() - new Date(onScene.createdAt).getTime()) / 1000
        );

        const h = Math.floor(diff / 3600);
        const m = Math.floor((diff % 3600) / 60);
        const s = diff % 60;

        duration = `${h ? h + 'h ' : ''}${m ? m + 'm ' : ''}${s ? s + 's' : ''}`.trim();
      }

      if (onScene && offScene) {
        result.push({
          user: `${user.firstName} ${user.lastName}`,
          scheduledDate,
          startTime: onScene.createdAt,
          endTime: offScene.createdAt,
          duration
        });
      }
    }

    return result;
  }
}
